module.exports = __webpack_public_path__ + "static/media/reclamation-icon-Mrh.7271bfd5.svg";